import React from 'react';
// @ts-ignore
import { Heading, HorizontalRule } from 'arag-ui-lib';
// @ts-ignore
import { FormikProps } from 'formik';
import EditableQuestionsWithAnswer from '../editableQuestionWithAnswer/editableQuestionWithAnswer';
import { ObjectOfStrings } from '../../reducers/types';

type Props = {
    groupStepWithQuestions: {
        questions: Array<any>;
        name: string;
    };
    questionTypes: ObjectOfStrings;
    formikProps: FormikProps<any>;
};
const ClaimDetails = (props: Props): JSX.Element => {
    const { groupStepWithQuestions, formikProps, questionTypes } = props;

    return (
        <div>
            <div>
                <Heading variant="h3" title={groupStepWithQuestions.name} />
                <div className={'form-horizontal'}>
                    <EditableQuestionsWithAnswer
                        questions={groupStepWithQuestions.questions}
                        questionTypes={questionTypes}
                        formikProps={formikProps}
                    />
                </div>
                <HorizontalRule variant={'pale'} />
            </div>
        </div>
    );
};

export default ClaimDetails;
